import $foreign from "./foreign.cjs";
var iterate = $foreign.iterate;
export { iterate };
